import api from "@/api.js";

export default {
  namespaced: true,
  modules: {},
  state: {
    yearTotal: null,
    yearTotalLoading: false,
  },
  mutations: {
    setYearTotal(state, payload) {
      state.yearTotal = payload;
    },
    seYearTotalLoading(state, payload) {
      state.yearTotalLoading = payload;
    },
  },
  actions: {
    async loadTotalForYear({ commit }, payload) {
      commit("seYearTotalLoading", true);
      let list = await api.get("/outcomes/data/totalForYear", {
        params: { id: payload.id, year: payload.year },
      });
      commit("setYearTotal", list.data);
      commit("seYearTotalLoading", false);
    },
  },
  getters: {
    yearTotal(state) {
      return state.yearTotal;
    },
    yearTotalLoading(state) {
      return state.yearTotalLoading;
    },
  },
};
